var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataCatalogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53874 1.81366C4.85874 1.81366 1.87207 4.80033 1.87207 8.48033C1.87207 12.1603 4.85874 15.147 8.53874 15.147C12.2187 15.147 15.2054 12.1603 15.2054 8.48033C15.2054 4.80033 12.2187 1.81366 8.53874 1.81366ZM8.53874 11.4803C6.87874 11.4803 5.53874 10.1403 5.53874 8.48033C5.53874 6.82033 6.87874 5.48033 8.53874 5.48033C10.1987 5.48033 11.5387 6.82033 11.5387 8.48033C11.5387 10.1403 10.1987 11.4803 8.53874 11.4803ZM8.53874 7.81366C8.17207 7.81366 7.87207 8.11366 7.87207 8.48033C7.87207 8.84699 8.17207 9.14699 8.53874 9.14699C8.9054 9.14699 9.2054 8.84699 9.2054 8.48033C9.2054 8.11366 8.9054 7.81366 8.53874 7.81366Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCatalogs);
export default __webpack_public_path__ + "static/media/data-catalogs.5b3199318e61808b46003b0a563e0dfb.svg";
export { ForwardRef as ReactComponent };